export const svgIcon = (icon, stack, className) => {
	let useStack = stack || 'invia';

	return `
		<span class="icon-svg icon-svg--${icon}${className ? ' ' + className : ''}">
			<svg class="icon-svg__svg" xmlns:xlink="http://www.w3.org/1999/xlink">
				<use xlink:href="/assets/${useStack}/img/bg/icons-svg.svg#icon-${icon}" x="0" y="0" width="100%" height="100%"></use>
			</svg>
		</span>
	`;
};
